<template>
    <v-container class="cards">
        <v-row align=center justify="center">
            <v-col cols=12 align=center>
                <a :href="portfolioUrl" target="_blank" style="text-decoration: none;">
                    <v-img width="500px" height="100px" class="rounded-xl elevation-2" :src="require('@/assets/portfolio.jpg')">
                        <v-row justify="center" align=center>
                            <v-col cols=12 align=center :style="$vuetify.breakpoint.mobile ? 'font-size: 20px;' : 'font-size: 22px;'" style="color: #7b7b7d;" :class="$vuetify.breakpoint.mobile ? 'mt-6' : 'mt-8'" class="font-weight-bold py-0">
                                {{language=='Ελληνικά'? 'Κατεβάστε το portfolio μας!' : 'Download our portfolio!'}}
                                <v-icon v-if="!$vuetify.breakpoint.mobile" x-large color="#FF5252">
                                    mdi-cloud-download-outline
                                </v-icon>
                            </v-col>
                            <v-col cols=12 v-if="$vuetify.breakpoint.mobile" class="my-0 py-0">
                                <v-icon large color="#FF5252">
                                    mdi-cloud-download-outline
                                </v-icon>
                            </v-col>
                        </v-row>
                    </v-img>
                </a>
            </v-col>
        </v-row>
        <v-row no-gutters justify="center" class="mt-5">
            <v-col cols=12 xs="12" sm="12" md="12" lg="6" xl="6">
                <v-card class="my-5 mx-5 about rounded-xl">
                    <div class="box">
                        <v-img
                        class="white--text rounded-xl"
                        height="50%"
                        src="@/assets/New-Projects.jpg"
                        >
                        </v-img>
                    </div>

                    <v-card-title class="pb-2 text-center">{{language=='Ελληνικά'? 'Καινούργια έργα' : 'Newest Projects'}}</v-card-title>

                    <v-card-text class="text--primary">
                        {{language=='Ελληνικά'? 'Δείτε εδώ τα καινούργια μας έργα' : 'See here our newest projects!'}}    
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                            color="black"
                            text
                            to="/Projects/All"
                        >
                            {{language=='Ελληνικά'? 'ΕΞΕΡΕΥΝΗΣΤΕ ΤΑ' : 'EXPLORE THEM'}} 
                            <span class="material-icons red-icon">
                                arrow_forward_ios
                            </span>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols=12 xs="12" sm="12" md="12" lg="6" xl="6">
                <v-card class="mx-5 my-5 rounded-xl">
                    <div class="box">
                        <v-img
                        class="white--text rounded-xl"
                        height="50%"
                        src="@/assets/Old-Projects.jpg"
                        >
                        </v-img>
                    </div>

                    <v-card-title class="pb-2 text-center">{{language=='Ελληνικά'? 'Παλαιότερα έργα' : 'Oldest Projects'}} </v-card-title>

                    <v-card-text class="text--primary">
                        {{language=='Ελληνικά'? 'Δείτε εδώ τα παλαιότερα μας έργα' : 'See here our oldest projects!'}} 
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                            color="black"
                            text
                            to="/Projects/All/Old"
                        >
                            {{language=='Ελληνικά'? 'ΕΞΕΡΕΥΝΗΣΤΕ ΤΑ' : 'EXPLORE THEM'}} 
                            <span class="material-icons red-icon">
                                arrow_forward_ios
                            </span>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="about.videoUrl" no-gutters justify="center" class="mt-16">
            <v-col cols=12>
                <v-img
                    class="rounded-xl"
                    width="100%"
                    :height="$vuetify.breakpoint.mobile? '300px' : '700px'"
                    :src="require('@/assets/portfolio-square.jpg')"
                >
                    <iframe class="iframe-container rounded-xl mt-15" :width="$vuetify.breakpoint.mobile? '100%' : '80%'" :height="$vuetify.breakpoint.mobile? '200px' : '540px'" :src="`${about.videoUrl}?autoplay=1&loop=1&mute=1&controls=0&showinfo=0&playlist=${videoCode}`" title="Youtube Video" frameborder="0" allow="autoplay" allowfullscreen />
                </v-img>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import restApi from "@/rest-api";
export default {
    props: {
        language: String
    },
    data() {
        return {
            portfolioUrl: '',
            about: null,
            videoCode: ''
        }
    },
    watch: {
        language() {
            this.getPortfolio()
        }
    },
    created() {
      this.getPortfolio()
      this.fetchAbout()
    },
    methods: {
        getPortfolio() {
            var search = `/portfolio/${this.language === 'English' ? 2 : 1}`
            restApi
            .get(search)
            .then(response => {
                let pdf = response.portfolio.image.imageName
                this.portfolioUrl = `https://dev.aggelopoulos-sarantis.com/uploads/images/${pdf}`
            })
            .catch((error) => {
                console.log(error)
            })
        },
        fetchAbout() {
            var search = `/about`;
            restApi
            .get(search)
            .then(response => {
                 this.about = response.data[0]
                 this.about.videoUrl = this.about.videoUrl.replace('watch', 'embed')
                 this.videoCode = this.about.videoUrl.split('/')
                 this.videoCode = this.videoCode[this.videoCode.length - 1]
            })
            .catch((error) => {
                console.log(error)
            })
        }
    }    
}
</script>

<style lang="scss" scoped>
    @media only screen and (min-width: 600px){
        .cards{
            width: 70%;
            margin-top: 5%;
            margin-bottom: 5%;
        }
    }
    @media only screen and (max-width: 600px){
        .cards{ 
            width: 100%;
            margin-top: 20%;
            margin-bottom: 20%;
        }
    }
    .cards{
        text-align: center;
    }
    .box{
        // text-align: center;
        width: 100%;       
    }    
    .box.large{
        height: 300px;
    }
    .box.small{
        height: 100px;
    }
    .v-card__title {
        display: block!important;
    }
    .grayscale{
        filter: grayscale(100%);
    }
    .red-icon {
        color: red;
    }
</style>